let stars = [];
let validPassword = '';
let errors = [];
let button = document.getElementById('submit');

$(document).ready(function () {
    $('.input_login').css('width', '100%');

    $(document).on('click', '.fechar_msg', function () {
        $.unblockUI();
        $('#black').hide();
    });

    $(document).on('click', '#linkEsqueciSenha', function () {

        if ($('#login input:text').eq(0).val() === '') {
            alert('Informe o usuário de sistema.');
            return;
        }

        if (confirm('Deseja realmente confirmar?')) {

            $.ajax({
                url: '/padrao/conta/enviasenha/',
                type: 'POST',
                cache: false,
                async: true,
                contentType: "application/x-www-form-urlencoded",
                data: {'usuario': $('#login input:text').eq(0).val()},
                beforeSend: function () {
                    $("#linkEsqueciSenha").after('<img id="loader" src="/img/ajax-loader-flower.gif">');
                },
                success: function (data) {
                    $('#black').show();

                    if (!data.success){
                        console.error(data.exception);
                    }

                    $.blockUI({
                        theme: true,
                        title: 'Envio de senha <a class="btn-i-nao right fechar_msg" href="javascript:;" style="margin-top:-3px"></a>',
                        message: '<h4 style="color:'+ data.color +'">' + data.msg + '</h4>'
                    });
                },
                complete: function () {
                    if ($('#loader').length > 0)
                        $('#loader').remove();
                },
                error: function (xh, desc, err) {
                    console.log(xh + " " + desc + " " + err);
                }
            });
        }
    });

    $(document).on('keydown', '#login input:text:eq(1)', function (e) {
        if (e.which === 13) {
            $('#submit').trigger('click');
        }
    });

    $(document).on('click', '#submit',function(event) {
        event.preventDefault();
        let form = new FormData();

        let user = $('#login input:text').eq(0).val();

        if(!user || !validPassword){
            alert('Informe o usuário e a senha!');
            return;
        }

        // Exemplo de uso:
        form.append('usuario', $('#login input:text').eq(0).val());
        form.append('senha', validPassword);

        $.ajax({
            url: '/padrao/conta/login/',
            type: 'POST',
            processData: false,
            contentType: false,
            async: true,
            cache: false,
            data: form,
            beforeSend: function() {
                $('#submit').html('Entrando... <img id="loader" src="/img/ajax-loader-flower.gif">');
            },
            success: function (data) {
                validPassword = '';
                if(data.success) {
                    window.location.href = data.url;
                    return;
                } else {
                    $('.bg_conteudo_login').html(data);

                }
                limpacampo();
            },
            error: function () {
                validPassword = '';
                limpacampo();
            },
            complete: function () {
                validPassword = '';
                errors = [];
            }
        });
    });
});

function getErro(mensagem) {
    let errorContent = document.getElementById('error-cnt');
    let errorMsg = document.getElementById('msg-error-login');

    errorContent.style.display = 'block';
    errorMsg.style.display = 'block';
    $('#submit').html('Entrar');
    errorMsg.innerHTML = '<h3>'+mensagem+'</h3>';
    if ($('#loader').length > 0)
        $('#loader').remove();
}

function limpacampo() {
    $('#login input:text').eq(0).val('');
    $('#login input:text').eq(1).val('');
}

function aplyMask(e) {
    const input = e.target;
    const valorDigitado = input.value;

    if (valorDigitado.length > validPassword.length) {
        const diff = valorDigitado.length - validPassword.length;

        const pastedChars = valorDigitado.replace(/•/g, '').slice(-diff);
        validPassword += pastedChars;
    }

    if (valorDigitado.length < validPassword.length) {
        const diff = validPassword.length - valorDigitado.length;
        validPassword = validPassword.slice(0, -diff);
    }

    input.value = '•'.repeat(validPassword.length);
}